import {
  LocalStorageFields,
  DefaultValues,
} from '../constants/localStorageConstants.js';

export default {
  install(Vue) {
    Vue.prototype.$localStorageObj = {
      data() {
        return {
          currentScale: '',
          currentDark: null,
          intervalTime: -1,
        };
      },

      getObjectFromStorage: (key) => {
        return JSON.parse(localStorage.getItem(key));
      },
      setObjectInStorage: (key, obj) => {
        localStorage.setItem(key, JSON.stringify(obj));
      },
      getScaleByUser(username) {
        if (
          this.currentScale !== null &&
          this.currentScale !== undefined &&
          this.currentScale !== ''
        )
          return this.currentScale;
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        this.currentScale = userObj[LocalStorageFields.SCALE];

        return this.currentScale;
      },
      setUserScale(value, username) {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        if (userObj[LocalStorageFields.SCALE] === value) return;
        userObj[LocalStorageFields.SCALE] = value;
        this.setObjectInStorage(username, userObj);
        this.currentScale = value;
      },
      getLangByUser(username) {
        if (!username) username = '';
        var userObj = this.getUserObject(username);

        return userObj[LocalStorageFields.LANG];
      },
      getUserObject(username) {
        var userObj = this.getObjectFromStorage(username);
        if (!userObj) userObj = {};
        if (this.checkUserObjOnDefaultProps(userObj))
          this.setObjectInStorage(username, userObj);

        return userObj;
      },
      checkUserObjOnDefaultProps(userObj) {
        let isChanged = false;
        if (userObj == null) {
          userObj = {};
          isChanged = true;
        }

        for (var key in DefaultValues.USER_OBJ)
          if (userObj[key] === undefined) {
            userObj[key] = DefaultValues.USER_OBJ[key]();
            isChanged = true;
          }

        return isChanged;
      },
      setUserLang(value, username) {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        if (userObj[LocalStorageFields.LANG] === value) return;
        userObj.lang = value;
        this.setObjectInStorage(username, userObj);
      },

      getLogoutCounterByUser(username) {
        if (!username) return 0;
        var userObj = this.getUserObject(username);

        return userObj[LocalStorageFields.LOGOUT_COUNTER];
      },
      setLogoutCounterScale(value, username) {
        if (!username) return;
        var userObj = this.getUserObject(username);
        if (userObj[LocalStorageFields.LOGOUT_COUNTER] === value) return;
        userObj[LocalStorageFields.LOGOUT_COUNTER] = value;
        this.setObjectInStorage(username, userObj);
      },

      getDarkValue() {
        if (this.currentDark === null || this.currentDark === undefined) {
          var userObj = this.getUserObject('');
          this.currentDark = userObj[LocalStorageFields.IS_DARK];
        }

        return this.currentDark;
      },
      setDarkValue(value) {
        if (this.currentDark !== null && this.currentDark === value) return;
        var userObj = this.getUserObject('');
        if (userObj[LocalStorageFields.IS_DARK] === value) return;
        userObj[LocalStorageFields.IS_DARK] = value;
        this.currentDark = value;
        this.setObjectInStorage('', userObj);
      },

      getIntervalTime() {
        if (this.intervalTime !== -1) {
          var userObj = this.getUserObject('');
          this.intervalTime = userObj[LocalStorageFields.INTERVAL_TIME];
        }

        return this.intervalTime;
      },

      setIntervalTime(value) {
        if (this.intervalTime !== null && this.intervalTime === value) return;
        var userObj = this.getUserObject('');
        this.intervalTime = value;
        if (userObj[LocalStorageFields.INTERVAL_TIME] === value) return;
        userObj[LocalStorageFields.INTERVAL_TIME] = value;
        this.setObjectInStorage('', userObj);
      },

      getKeepFiltersValue(username = '') {
        if (!username) username = '';
        const existed = this.getObjectFromStorage(username) != null;
        var userObj = this.getUserObject(username);
        if (username !== '' && !existed) {
          var globalObj = this.getUserObject('');
          const globalValue = globalObj[LocalStorageFields.KEEP_FILTERS] === true;
          if (globalValue) {
            userObj[LocalStorageFields.KEEP_FILTERS] = true;
            this.setObjectInStorage(username, userObj);
          }
        }

        return userObj[LocalStorageFields.KEEP_FILTERS] === true;
      },

      setKeepFiltersValue(value, username = '') {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        if (userObj[LocalStorageFields.KEEP_FILTERS] === value) return;
        userObj[LocalStorageFields.KEEP_FILTERS] = value;

        if (value === false) {
          const bankPrefix = LocalStorageFields.BANK_FILTER;
          const branchPrefix = LocalStorageFields.BRANCH_FILTER;
          Object.keys(userObj).forEach((key) => {
            if (
              key === bankPrefix ||
              key.startsWith(bankPrefix + '_') ||
              key === branchPrefix ||
              key.startsWith(branchPrefix + '_')
            ) {
              delete userObj[key];
            }
          });
        }

        this.setObjectInStorage(username, userObj);
      },

      getBankFilter(pageKey = '', username = '') {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        const key = pageKey ? `${LocalStorageFields.BANK_FILTER}_${pageKey}` : LocalStorageFields.BANK_FILTER;

        return userObj[key] || [];
      },

      setBankFilter(value, pageKey = '', username = '') {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        const key = pageKey ? `${LocalStorageFields.BANK_FILTER}_${pageKey}` : LocalStorageFields.BANK_FILTER;
        userObj[key] = value;
        this.setObjectInStorage(username, userObj);
      },

      getBranchFilter(pageKey = '', username = '') {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        const key = pageKey ? `${LocalStorageFields.BRANCH_FILTER}_${pageKey}` : LocalStorageFields.BRANCH_FILTER;

        return userObj[key] || [];
      },

      setBranchFilter(value, pageKey = '', username = '') {
        if (!username) username = '';
        var userObj = this.getUserObject(username);
        const key = pageKey ? `${LocalStorageFields.BRANCH_FILTER}_${pageKey}` : LocalStorageFields.BRANCH_FILTER;
        userObj[key] = value;
        this.setObjectInStorage(username, userObj);
      },
    };
  },
};
